import { useState } from 'react';
import { LoadRequestChat } from '../LoadRequestChat';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

export const LandingTryChat = () => {
  const [open, setOpen] = useState(false);
  const [pendingLoad, setPendingLoad] = useState<any>(null);
  const navigate = useNavigate();
  const { language } = useLanguage();

  const handleRequireAuth = (loadData: any) => {
    setPendingLoad(loadData);
    setOpen(true);
  };

  const goToAuth = () => {
    // Optional: persist pendingLoad if we want to resume after signup
    // sessionStorage.setItem('pendingLoad', JSON.stringify(pendingLoad));
    navigate('/auth');
  };

  return (
    <section className="py-12 px-2 sm:px-4">
      <div className="w-full mx-auto max-w-5xl">
        <LoadRequestChat 
          companyName="Guest"
          onLoadConfirmed={() => { /* no-op in preview */ }}
          previewMode
          onRequireAuth={handleRequireAuth}
          customTitle={language === 'ar' ? 'تجربة الذكاء الاصطناعي' : 'Try the AI'}
        />
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-[92vw] sm:max-w-lg p-6 sm:p-8 rounded-xl">
          <DialogHeader className="text-center space-y-2">
            <DialogTitle>{language === 'ar' ? 'سجّل الان لإستكمال طلبك' : 'Sign up to submit your request'}</DialogTitle>
          <DialogDescription>
            {language === 'ar'
              ? 'تم حفظ تفاصيل شحنتك بنجاح. أنشئ حسابًا مجانيًا لإرسالها للناقلين ومتابعة الطلبات بشكل لحظي.'
              : 'We captured your load details. Create a free account to send it to carriers and track responses.'}
          </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button onClick={goToAuth} variant="accent" className="w-full sm:w-auto h-12 sm:h-11 text-base">
              {language === 'ar' ? 'تابع للتسجيل' : 'Continue to sign up'}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </section>
  );
};
